// extracted by mini-css-extract-plugin
export var borderRadius = "_fb-4";
export var large = "_fb-3";
export var logoContainer = "_fb-0";
export var nameLogo = "_fb-2";
export var small = "_fb-1";